import { render, staticRenderFns } from "./InvitationPage.vue?vue&type=template&id=53f4c70a&scoped=true"
import script from "./InvitationPage.vue?vue&type=script&lang=js"
export * from "./InvitationPage.vue?vue&type=script&lang=js"
import style0 from "./InvitationPage.vue?vue&type=style&index=0&id=53f4c70a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53f4c70a",
  null
  
)

export default component.exports